export const TeacherDatalist = [
    {
        name: "唐老师",
        introduce: "本科畢業於西安外國語大學，研究生畢業於集美大學，擁有紮實的語言學與教育背景。曾任教於環球雅思國際英語，具備豐富的教學經驗，尤其擅長3-12歲學生的全英文授課。擅長透過生動的課堂互動和高效的學習策略激發學生興趣，培養英語聽讀寫綜合能力。在其指導下，學生成績平均維持在95分以上。",
        picture: "../assets/hkEngimg/tang.jpg"
    },
    {
        name: "高老师",
        introduce: "香港理工大學英語教育專業畢業，擁有多年的英語教學經驗，專注於培養學生的聽、說、讀、寫全方位能力。善於針對不同年齡和學習需求設計個性化教學方案，寓教於樂，讓學生在輕鬆愉快的氛圍中掌握英語。曾幫助眾多學生提高學業成績及英語口語水平，深受家長和學生的喜愛與好評。無論是希望提升應試能力，還是學習實用英語，该老師都能提供專業且高效的指導！",
        picture: "../assets/hkEngimg/gao.jpg"
    },
    {
        name: "Betti",
        introduce: "8年教培產業一線代課+教研經驗；6年教培業創業經驗；5年多的教輔圖書責編經驗 ，紮實系統的英語專業知識，能夠快速解決專業方面的問題 ，提高工作效率 。同時，豐富的教研經驗也讓其具備了較強的課程開發和教材編寫能力 ，能夠根據教學目標和學生特點 ，制定合理的教學計劃和教學方法。",
        picture: "../assets/hkEngimg/betti.jpg"
    }];
export const talkList = ['../assets/hkEngimg/pl11.jpg', '../assets/hkEngimg/pl22.jpg', '../assets/hkEngimg/pl33.jpg', '../assets/hkEngimg/pl44.jpg', '../assets/hkEngimg/pl5.jpg']
